import axios from "axios";
import _ from "lodash";
import Vue from 'vue'
import StudyEstEukTechMapApiService from "../../../components/application/study/Services/Api/StudyEstEukTechMapApi";
import store from "../index.js.erb";

const StudyEstEukTechMapApi = StudyEstEukTechMapApiService

const StudyEstEukTechMapStore = {
    namespaced: true,
    state: {
        index_technical_maps: [],
        technical_map: {},
        loading_list_tech_maps: false,
        response: {},
        status_snackbar: false
    },

    getters: {

    },

    mutations: {
        setTechnicalMap(state, response){
            state.technical_map = response
        },
        setIndexTechnicalMaps(state, response){
            state.index_technical_maps = response
        },
        resetStudyEstEukTechMapStore(state){
            state.index_technical_maps = []
            state.technical_map = {}
            state.loading_list_tech_maps = false
            state.response = {}
        },
        setResponse(state, response){
            state.response = response
        },
        setStatusSnackbar(state){
            state.status_snackbar = !state.status_snackbar
        }
    },

    actions: {
        async postTechnicalMap({commit, dispatch}, data_tech_map) {
            const response = await StudyEstEukTechMapApi.create(data_tech_map);

            dispatch('getTechnicalMap', response.data.course_id)
            commit('setResponse', response)
            commit('setStatusSnackbar')
        },
        async getTechnicalMap({commit}, course_id) {
            const response = await StudyEstEukTechMapApi.show(course_id);

            if (_.isNull(response.data.technological_map)) return null

            commit('setTechnicalMap', response.data.technological_map)

            if (!response?.data.hasOwnProperty("error")) {

            } else {
                console.log('error')
            }
        },
        async updateTechnicalMap({commit, dispatch}, data_tech_map) {
            const response = await StudyEstEukTechMapApi.update(data_tech_map);
            if (_.isNull(response)) return;

            dispatch('getTechnicalMap', response.data.course_id)

            if (!response?.data.hasOwnProperty("error")) {

            } else {
                console.log('error')
            }
        },
        async indexTechnicalMaps({state, commit}) {
            state.loading_list_tech_maps = true

            const response = await StudyEstEukTechMapApi.index()

            state.loading_list_tech_maps = false


            if (_.isNull(response.data.technological_maps)) return null

            commit('setIndexTechnicalMaps', response.data.technological_maps)

            if (!response?.data.hasOwnProperty("error")) {

            } else {
                console.log('error')
            }
        },
        async getDetailsTechnicalMaps({state, commit}, course_id) {
            const response = await StudyEstEukTechMapApi.show_commission_details_tech_map(course_id)

            if (_.isNull(response.data.technological_map)) return null

            commit('setTechnicalMap', response.data.technological_map)

            if (!response?.data.hasOwnProperty("error")) {

            } else {
                console.log('error')
            }
        },
    },
}

export default StudyEstEukTechMapStore